<template>
  <div class="after_sales_page page">
    <div class="top_bg">
      <img src="../assets/introduce_bg.png">
    </div>

    <b-container class="after_sales_content my_content">
      <p class="title">售后服务中心</p>

      <div class="after_sales_container">
        <b-row class="top">
          <b-col class="item"><img src="../assets/after_sales1.png" width="68"></b-col>
          <b-col class="item"><img src="../assets/after_sales2.png" width="68"></b-col>
          <b-col class="item"><img src="../assets/after_sales3.png" width="68"></b-col>
          <b-col class="item"><img src="../assets/after_sales4.png" width="68"></b-col>
        </b-row>
        <div class="line_box clearfix">
          <div class="point"></div>
          <div class="line"></div>
          <div class="point"></div>
          <div class="line"></div>
          <div class="point"></div>
          <div class="line"></div>
          <div class="point"></div>
        </div>
        <b-row class="top">
          <b-col class="item">在线登记</b-col>
          <b-col class="item">寄送产品</b-col>
          <b-col class="item">售后处理</b-col>
          <b-col class="item">寄回</b-col>
        </b-row>
      </div>

      <div class="tabs">
        <div class="tab" v-for="(item,index) in tabsList" :class="{'active':currentTab === item.id}"
             @click="switchTab(item.id)" :key="index">
          <div class="box_inner" v-if="index === 0 || ((index === tabsList.length-1) && index > 0)">
            {{ item.name }}
          </div>
          <span v-if="index > 0 && (index < tabsList.length-1)">{{ item.name }}</span>
        </div>
      </div>

      <div class="remind">
        <p class="title">温馨提示</p>
        <p>由于美国政府的限制，Lexar不能获取任何美国终端客户的个人信息</p>
        <p>美国的终端客户，请联系我们北美区呼叫中心，协助处理售后事宜，详细联系方式如下</p>
        <div>
          North America<br>
          Toll-free US & Canada: 1-877-747-4031<br>
          Hours(PST):Monday-Friday,7am-5pm<br>
          E-mail:support@lexar.zendesk.com
        </div>
      </div>

    </b-container>
  </div>
</template>

<script>
export default {
  name: "AfterSales",
  data() {
    return {
      tabsList: [
        {id: 1, name: "售后申请"},
        {id: 2, name: "进度查询"}
      ],
      currentTab: 1,
      languageNum: window.localStorage.getItem("languageNum"),
    }
  },
  methods: {
    switchTab() {
      window.open('http://rma.lexar.com/')
      // this.currentTab = tabId
    },

  }
}
</script>

<style scoped lang="scss" src="../css/afterSales.scss">

</style>